import VueStoragePlugin from 'vue-ls'

const webStorage = VueStoragePlugin.useStorage({
  namespace: 'pro__',
  name: 'ls',
  storage: 'local'
})
export const storage = webStorage.ls
